export default "__VITE_ASSET__CpVn4_kj__"